import { type ComponentProps, useState } from "react";
import { images } from "../constants";
import { QuickEstimateInput } from "../types";
import {
  FreeCheckBadge,
  FreeCheckCard,
  FreeCheckCta,
  FreeCheckForm,
  FreeCheckInput,
  FreeCheckInputSuffix,
  FreeCheckNumberField,
  FreeCheckNumberInput,
  FreeCheckTitle,
  Cta02SectionRoot,
} from "../styles";

type Cta02SectionProps = {
  onSubmit: (value: QuickEstimateInput) => void;
};

export default function Cta02Section({ onSubmit }: Cta02SectionProps) {
  const [mansionName, setMansionName] = useState("");
  const [roomNumber, setRoomNumber] = useState("");

  const handleSubmit: NonNullable<ComponentProps<"form">["onSubmit"]> = (event) => {
    event.preventDefault();
    onSubmit({
      mansionName: mansionName.trim(),
      roomNumber: roomNumber.trim(),
      source: "cta02",
    });
  };

  return (
    <Cta02SectionRoot>
      <FreeCheckCard>
        <FreeCheckBadge>カンタン入力60秒</FreeCheckBadge>
        <FreeCheckTitle>売却無料相談はこちらから</FreeCheckTitle>
        <FreeCheckForm onSubmit={handleSubmit}>
          <FreeCheckInput
            type="text"
            name="mansionName"
            placeholder="マンション名"
            value={mansionName}
            onChange={(event) => setMansionName(event.target.value)}
            required
          />
          <FreeCheckNumberField>
            <FreeCheckNumberInput
              type="text"
              name="roomNumber"
              placeholder="部屋番号"
              value={roomNumber}
              onChange={(event) => setRoomNumber(event.target.value)}
              required
            />
            <FreeCheckInputSuffix>号室</FreeCheckInputSuffix>
          </FreeCheckNumberField>
          <FreeCheckCta type="submit" $backgroundImage={images.ctaButton}>
            無料売却相談をする
          </FreeCheckCta>
        </FreeCheckForm>
      </FreeCheckCard>
    </Cta02SectionRoot>
  );
}
